import { useCreateNoteMutation } from 'app/services/notes';
import { AddBlackIcon } from 'assets/icons';
import MessageBox from 'Components/Form/MessageBox';
import { errorToast, successToast } from 'Components/Notifications';
import { PaginationContext } from 'Components/Pagination/usePagination';
import Tooltip from 'Components/Tooltips';
import { useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';

export default function CreateNote({
  projectId,
  taskId,
  documentId,
  label = 'Note',
}: {
  projectId?: number;
  taskId?: number;
  documentId?: number;
  label?: string;
}) {
  const { handleSubmit, setValue, control } = useForm<{ noteBody: string }>();

  const { refetchAfterAdd } = useContext(PaginationContext);

  const [createNote, { isLoading }] = useCreateNoteMutation();

  return (
    <form
      onSubmit={handleSubmit(({ noteBody }: { noteBody: string }) => {
        createNote({
          body: noteBody,
          task_id: taskId,
          project_id: projectId,
          document_id: documentId,
        })
          .unwrap()
          .then(() => {
            refetchAfterAdd();
            successToast(`${label} Created Successfully`);
            setValue('noteBody', '');
          })
          .catch(() => errorToast(`Couldn't create note ${label}`));
      })}
    >
      <Controller
        name={'noteBody'}
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <MessageBox
            value={value}
            onChange={onChange}
            button={
              <Tooltip message={`Add ${label}`}>
                <button
                  disabled={isLoading}
                  className="focus:outline-none flex-1 rounded-2xl "
                >
                  <AddBlackIcon className="w-4 h-4 text-gray-dark" />
                </button>
              </Tooltip>
            }
          />
        )}
      />
    </form>
  );
}
